<template>
  <section>
    <pageHeader><h1 class="qrs-header-xl">Question set title</h1></pageHeader>
    <backButton :goBack="goBack" />

    <p>{{ jsonData }}</p>

    <div class="govuk-form-group mt--24">
      <h3 class="govuk-label-wrapper mb--8">Question title</h3>
      <textarea class="govuk-textarea" id="content"></textarea>
    </div>



  </section>
</template>

<script>
const Display_Landing = "mainLanding";

export default {
  name: "questionSet",

  props: {
    jsonData: Object,
  },

  data() {
    return {};
  },

  methods: {
    goBack() {
      this.$parent.display = Display_Landing;
      // this.qidx = 0;
    },
    displayClicked(display) {
      this.display = display;
    },
  },
};
</script>